module.exports = __webpack_public_path__ + "img/2021-05.e46df931.jpg";